/* =============================================================
   Loon'r PDP — variant picker + size unit toggle + ATC.
   Reads variants list embedded in the section via <script type="application/json" ...>.
   ============================================================= */

(function () {
  "use strict";

  const variantsEl = document.querySelector("[data-loonr-product-variants]");
  const configEl = document.querySelector("[data-loonr-option-config]");
  if (!variantsEl || !configEl) return;

  const variants = JSON.parse(variantsEl.textContent);
  const config = JSON.parse(configEl.textContent);
  const colorIndex = config.colorIndex;
  const sizeIndex = config.sizeIndex;
  const productMeta = config.product || {};
  // Pre-order (Step 3): Stoq created a real Shopify selling plan. We read its id
  // + the ship-date copy server-side so the buy path is Shopify-native and does
  // NOT depend on Stoq's JS staying up — a flaky embed can't oversell.
  const preorderPlanId = config.preorderPlanId || null;
  const preorderShip = config.preorderShip || "Ships soon";

  // SKUs we ordered ZERO of from the factory (F26 Factory Order, June 2026).
  // These must never show pre-order; they fall through to "Holler when it's back"
  // (notify-me) so we capture interest without promising a boot we won't have.
  // Theme-side guard. A store-level inventory-policy lock (DENY) is applied in tandem.
  // Ground Control M4/W5 (BRN) + Mermaid Motel M14/15 (TEA) were opened 2026-07-22
  // after the supplementary RunLei order added units for those cells (+5 / +10 pairs).
  const UNORDERED_SKUS = new Set([
    "LNR-HF-PNK-1415", // Hi Flyer, Floyd, M14/15
    "LNR-HF-PUR-1415", // Hi Flyer, Paisley Park, M14/15
    "LNR-HF-YEL-1415", // Hi Flyer, Sunshine Daydream, M14/15
    "LNR-LR-PNK-1415", // Lo Rider, Floyd, M14/15
  ]);

  const swatches = document.querySelectorAll(".swatch[data-option-value]");
  const sizeSelect = document.getElementById("size-select-loonr");
  const variantIdInput = document.querySelector("[data-variant-id-input]");
  const atc = document.getElementById("atc-loonr");
  const priceEl = document.querySelector("[data-price]");
  const skuEl = document.querySelector("[data-current-sku]");

  // Per-size spec swap (Weight / Boot height / Cuff circumference) with an
  // Imperial (default) / Metric unit toggle. Map emitted by the section as
  // <script data-loonr-size-specs>, keyed by Size value, each entry holding
  // both unit strings (w_i/w_m, c_i/c_m, h_i/h_m) + est flag. Empty {} for
  // Sidekick -> static VERIFY placeholders stay. Source: docs/boot-specs-2026.md.
  const sizeSpecsEl = document.querySelector("[data-loonr-size-specs]");
  let sizeSpecs = {};
  if (sizeSpecsEl) { try { sizeSpecs = JSON.parse(sizeSpecsEl.textContent) || {}; } catch (e) { sizeSpecs = {}; } }
  const specWeightEl = document.querySelector("[data-spec-weight]");
  const specOuterHeightEl = document.querySelector("[data-spec-outer-height]");
  const specInnerHeightEl = document.querySelector("[data-spec-inner-height]");
  const specCircEl = document.querySelector("[data-spec-circ]");

  // Per-colorway PDP description: swaps the Description accordion lead on color change.
  const colorwayCopyEl = document.querySelector("[data-loonr-colorway-copy]");
  let colorwayCopy = {};
  if (colorwayCopyEl) { try { colorwayCopy = JSON.parse(colorwayCopyEl.textContent) || {}; } catch (e) { colorwayCopy = {}; } }
  const colorwayDescEl = document.querySelector("[data-colorway-desc]");

  function applyColorwayDesc(color) {
    if (!colorwayDescEl) return;
    function norm(s) { return (s || "").replace(/’/g, "'"); } // tolerate curly vs straight apostrophes
    let copy = colorwayCopy[color];
    if (copy === undefined) {
      const target = norm(color);
      for (const k in colorwayCopy) { if (norm(k) === target) { copy = colorwayCopy[k]; break; } }
    }
    colorwayDescEl.innerHTML = copy ? ("<p>" + copy + "</p>") : "";
    applyBside(color);
  }

  // B-side hunt (Mike 2026-10-06): the record link in the Description accordion
  // follows the selected colorway (snippets/loonr-bside.liquid holds the map).
  const bsideEl = document.querySelector("[data-bside]");
  // Each color's B-side lives on a hidden page; the page source only ever holds the
  // current color's link (Mike 2026-10-07), so a color change asks the server for it.
  let bsideColor = bsideEl ? bsideEl.getAttribute("data-bside-color") : null;
  let bsideReq = 0;
  // Move the record into the hiding spot set for this color (falls back to the Description).
  function placeBside(spot) {
    const slot = document.querySelector('[data-bside-slot="' + spot + '"]') || document.querySelector('[data-bside-slot="desc"]');
    if (slot && bsideEl.parentNode !== slot) slot.appendChild(bsideEl);
  }
  if (bsideEl) placeBside(bsideEl.getAttribute("data-bside-spot") || "desc");
  function applyBside(color) {
    if (!bsideEl) return;
    const hex = colorAccentMap[color];
    if (hex) bsideEl.style.color = /^#f{6}$/i.test(hex) ? "#9C9587" : hex; // white boots: a visible gray
    if (color === bsideColor) return;
    bsideColor = color;
    bsideEl.hidden = true;
    const v = typeof currentVariant !== "undefined" && currentVariant ? currentVariant.id : null;
    if (!v) return;
    const req = ++bsideReq;
    fetch((bsideEl.getAttribute("data-bside-product") || location.pathname) + "?variant=" + v + "&view=bside", { credentials: "same-origin" })
      .then(r => (r.ok ? r.text() : ""))
      .then(t => {
        if (req !== bsideReq) return;
        const parts = (t || "").trim().split("|");
        const url = parts[0], spot = parts[1] || "desc";
        if (/^\/pages\/b-side-[a-z0-9]+$/.test(url)) { bsideEl.href = url; placeBside(spot); bsideEl.hidden = false; }
      })
      .catch(() => {});
  }

  function applySpecs(variant) {
    if (!variant || sizeIndex < 0) return;
    const size = variant.options[sizeIndex];
    const spec = sizeSpecs[size];
    if (!spec) return; // no data for this boot/size -> leave static fallback
    // Show both unit systems side by side, e.g. "1 lb 7 oz / 660 g".
    function set(el, imp, met) {
      if (!el) return;
      el.textContent = imp + " / " + met;
      el.setAttribute("data-estimated", spec.est ? "1" : "0");
    }
    set(specWeightEl, spec.w_i, spec.w_m);
    set(specOuterHeightEl, spec.oh_i, spec.oh_m);
    set(specInnerHeightEl, spec.ih_i, spec.ih_m);
    set(specCircEl, spec.c_i, spec.c_m);
  }

  const colorNameEls = document.querySelectorAll("[data-current-color]");
  const colorPickerName = document.querySelector("[data-color-name]");
  const heroImg = document.querySelector("[data-hero-img]");
  const subheadEm = document.querySelector(".buybox h1.product-title em[data-current-color]");

  // Per-color hex for the subheadline accent. Frosty's Flake is true white and
  // gets a black outline via the .needs-outline class (applyColorAccent adds it
  // when isLightColor(hex) && no subheadDarkMap override).
  // Dark Side of the Loon stays dark ink — black on cream reads cleanly without
  // needing an outline.
  const colorAccentMap = {
    "Lipstick Rodeo":         "#E83C45",
    "Mermaid Motel":          "#00BFB8",
    "Paisley Park":           "#7B428A",
    "Floyd":                  "#DE4668",
    "Sunshine Daydream":      "#F1C400",
    "Palisade Peach":         "#FF6727",
    "Pass the Peas":          "#40725A",
    "Frosty's Flake":         "#FFFFFF",
    "Dark Side of the Loon":  "#2D2926",
    "A Glacier's Bummock":    "#00629D",
    "Ground Control":         "#47372A",
    // Sidekick colorways — Midnight Disco is straight dark, Moss Pit is
    // medium mossy green. If Mike has exact spec hexes from the factory
    // sample, drop them in here and the subhead / dot / unit-pill all auto-
    // retint via the existing --swatch-accent flow.
    "Midnight Disco":         "#1A1A1A",
    // Moss Pit: measured off the production boot (2026-09-18 shoot, shell median
    // RGB 76,87,90). The old #4F6B33 described the forest-green pre-production sample.
    "Moss Pit":               "#4C575A",
  };

  // Colorway FIELDS for the two deep-dive bands below the buy box (2026-09-19 color pass).
  // [field, text on it, photo shadow, second band, text on the second band, shelf]
  // shelf = the "Two more boots" cross-sell panel that sits right above the field on desktop:
  // yellow like every other pick-a-boot shelf on the site, teal when the field is yellow.
  // The field is the colorway itself, pressed deeper only where paper or ink body copy could
  // not reach 4.5:1 on the raw hex (red 3.8 -> #A82530 6.6, pink 3.8 -> #C23257 5.1,
  // green 5.2 -> #35604B 6.7). White has no field of its own, so Frosty's Flake borrows ink.
  // The second band is yellow, except where the field is already yellow or orange: teal then.
  // KEEP IN SYNC with the Liquid copy in sections/main-product-loonr.liquid (first paint).
  const INK = "#2D2926", PAPER = "#FFFDF6", YEL = "#F1C400", TEAL = "#00BFB8";
  const colorFieldMap = {
    "Lipstick Rodeo":         ["#A82530", PAPER, YEL, YEL,  INK, YEL],
    "Mermaid Motel":          ["#00BFB8", INK,   INK, YEL,  INK, YEL],
    "Paisley Park":           ["#7B428A", PAPER, YEL, YEL,  INK, YEL],
    "Floyd":                  ["#C23257", PAPER, YEL, YEL,  INK, YEL],
    "Sunshine Daydream":      ["#F1C400", INK,   INK, TEAL, INK, TEAL],
    "Palisade Peach":         ["#FF6727", INK,   INK, TEAL, INK, YEL],
    "Pass the Peas":          ["#35604B", PAPER, YEL, YEL,  INK, YEL],
    "Frosty's Flake":         ["#2D2926", PAPER, YEL, YEL,  INK, YEL],
    "Dark Side of the Loon":  ["#2D2926", PAPER, YEL, YEL,  INK, YEL],
    "A Glacier's Bummock":    ["#00629D", PAPER, YEL, YEL,  INK, YEL],
    "Ground Control":         ["#47372A", PAPER, YEL, YEL,  INK, YEL],
    "Midnight Disco":         ["#1A1A1A", PAPER, YEL, YEL,  INK, YEL],
    "Moss Pit":               ["#4C575A", PAPER, YEL, YEL,  INK, YEL],
  };

  // Darkened-but-hue-preserving hexes for the colorway SUBHEAD text only.
  // The boot photo, swatch ring, dot, and toggle pill still use the bright
  // brand hex from colorAccentMap — only the subhead em swaps to a deeper
  // tone where the bright color fails WCAG contrast on cream paper.
  // Mermaid Motel (teal, 2.25:1) → dark teal (~6.3:1).
  const subheadDarkMap = {
    // Yellow and Orange reverted to bright originals — Mike wanted to see if
    // letter-spacing alone reads better than darkening (preserves brand color
    // identity, relies on outline + spacing for legibility instead of fill).
    // Frosty's Flake reverted too (Mike, 2026-07-06): true-white fill matching
    // the boot + the .needs-outline ink stroke, same treatment as yellow/orange.
    "Mermaid Motel":     "#00696A",
  };

  function colorKey(name) {
    return (name || "").toLowerCase().replace(/'/g, "").replace(/\s+/g, "-");
  }

  // F26 colorway status map. Drives the hero stamp + new-strip copy.
  // Per-colorway F26 status. Used by applyColorStatus() to swap the hero
  // stamp + new-strip copy on swatch change. NOTE: Sidekick's two colorways
  // (Midnight Disco, Moss Pit) are mapped to "new" here because the whole
  // silhouette is new for F26 — Liquid already forces color_status = 'new'
  // on the Sidekick PDP, but this map keeps JS in sync if the user switches
  // colors after page load.
  const colorStatusMap = {
    "Lipstick Rodeo":         "new",
    "Mermaid Motel":          "new",
    "Ground Control":         "new",
    "Midnight Disco":         "new",
    "Moss Pit":               "new",
    "Paisley Park":           "refreshed",
    "Sunshine Daydream":      "refreshed",
    "A Glacier's Bummock":    "refreshed",
    "Dark Side of the Loon":  "carryover",
    "Frosty's Flake":         "carryover",
    "Pass the Peas":          "carryover",
    "Palisade Peach":         "carryover",
    "Floyd":                  "carryover",
  };

  // F26 pre-order ship window per colorway. Grouping is Mike's 2026-08-18 call
  // (green + brown on the last containers, black/purple/teal/blue on C2,
  // everything else incl. both Sidekicks on C1). Words re-set 2026-09-16 after
  // the vessel slip: C1 now reaches LBOE ~Oct 14-16 (forwarder's Sept 14 sheet:
  // ETA Long Beach Sep 29 + ~15 days rail), so C1 = "mid Oct", C2 = "late Oct",
  // C3/C4 = "early Nov". Deliberately the aggressive end of each range (Mike:
  // "be aggressive not conservative"). Values are full phrases now so the month
  // can differ per color; unlisted colorways default to the C1 window. Keep the
  // Liquid copy of this map in main-product-loonr.liquid (price-row ship window)
  // in sync.
  // Re-set 2026-10-06: green + brown "early-mid Nov" (Mike 10/6); everything else "mid Oct". Mike
  // 10/6: C1 starts shipping ~10/14 and C2 ~10/19, "I would call those BOTH
  // Mid-Oct" (so black, teal, blue and Paisley Park share the default window).
  // 10/17: late colors + window come from snippets/loonr-ship-rules.liquid via the PDP config;
  // the literals below are only a fallback for an older cached page.
  const shipWindowByColor = {};
  (Array.isArray(config.lateColors) ? config.lateColors : ["Pass the Peas", "Ground Control"])
    .forEach(c => { shipWindowByColor[c] = config.lateWindow || "mid Nov"; });
  // C1/C2 flip (Mike 10/16, staged): colors NOT in the map above now ship, not pre-order.
  // The phrase comes from snippets/loonr-ship-now.liquid via the PDP config (one-line swap).
  // Empty phrase = Mike's "doesn't need to show up on product page" option: no price-row line,
  // no Ships property for C1/C2 colors. Fill the snippet to bring the line back.
  const SHIP_NOW = (config.shipNow || "").trim();
  // Per-size truth (Sweep 10/17): stocked sizes are plain in-stock via variantState(); zero-stock
  // C1/C2 sizes are oversold onto C3 to C5 and stay pre-order with the Nov window. Override OFF.
  // The switch lives in main-product-loonr.liquid (per_size_truth) and arrives here via config.
  const PER_SIZE_TRUTH = config.perSizeTruth === true;
  function shipsNow(colorName) { return !PER_SIZE_TRUTH && !(colorName in shipWindowByColor); }
  function needsShipsProp(v) { const c = v.options[colorIndex]; return !shipsNow(c) || !!SHIP_NOW; }
  function shipFor(colorName) { return shipWindowByColor[colorName] || (PER_SIZE_TRUTH ? (config.oversoldWindow || "mid-late Nov") : SHIP_NOW); }
  // Value for the cart/checkout "Ships" line-item property, per color (e.g. "late Oct").
  function shipLabel(colorName) { return shipFor(colorName); }

  function applyColorStatus(colorName) {
    const status = colorStatusMap[colorName] || "carryover";
    const stamp = document.querySelector("[data-hero-stamp]");
    const strip = document.querySelector(".new-strip");
    const stripPill = document.querySelector("[data-status-pill]");
    const stripCopy = document.querySelector("[data-status-copy]");
    if (strip) strip.dataset.colorStatus = status;
    if (stamp) {
      stamp.dataset.colorStatus = status;
      let inner;
      if (status === "new") inner = `New '26 · <span data-current-color>${colorName}</span>`;
      else if (status === "refreshed") inner = `Refreshed '26 · <span data-current-color>${colorName}</span>`;
      else inner = `<span data-current-color>${colorName}</span> · Returning classic`;
      stamp.innerHTML = inner;
    }
    if (stripPill) {
      stripPill.textContent = status === "new" ? "New '26" : status === "refreshed" ? "Refreshed" : "Classic";
    }
    if (stripCopy) {
      let inner;
      if (status === "new") inner = `<strong data-current-color>${colorName}</strong> joins the lineup. <a href="#whats-new">See what's new for '26 →</a>`;
      else if (status === "refreshed") inner = `<strong data-current-color>${colorName}</strong> got a refresh for '26. <a href="#whats-new">See what's new →</a>`;
      else inner = `<strong data-current-color>${colorName}</strong> returns for '26. <a href="#whats-new">See what's new for '26 →</a>`;
      stripCopy.innerHTML = inner;
    }
  }
  // Color names with apostrophes stripped, for matching against filename-derived data-color
  // (which can't contain raw apostrophes in HTML attrs without escape gymnastics).
  function normalizeColorName(name) { return (name || "").replace(/'/g, ""); }

  // ── Responsive photos (Round 5 P2-12) ─────────────────────
  // The hero and the gallery cells carry a width-descriptor srcset built from their 1400w
  // Shopify CDN URL. The Liquid emits the same lists (srcset_hero_widths /
  // srcset_shot_widths in main-product-loonr.liquid), but only on the cells the first
  // colorway shows; the rest get theirs here the moment a swatch reveals them.
  const HERO_WIDTHS = [360, 540, 720, 900, 1100, 1400];
  const SHOT_WIDTHS = [360, 540, 720, 1000, 1400];
  const SHOT_SIZES = "(max-width: 640px) calc(100vw - 66px), (max-width: 960px) calc(50vw - 27px), (max-width: 1320px) calc(27vw - 40px), 318px";
  function srcsetFrom(url, widths) {
    if (!url || !/[?&]width=\d+/.test(url)) return "";
    return widths.map(w => url.replace(/([?&]width=)\d+/, "$1" + w) + " " + w + "w").join(", ");
  }
  function ensureShotSrcset(img) {
    if (!img || img.hasAttribute("srcset")) return;
    const set = srcsetFrom(img.getAttribute("src"), SHOT_WIDTHS);
    if (!set) return;
    img.setAttribute("sizes", SHOT_SIZES);
    img.setAttribute("srcset", set);
  }

  // The foam band's photo is the chosen colorway's own EVA, a region crop of its
  // side-profile studio shot (Round 5 P2-11). Map emitted by the section ({src, alt} keyed
  // by the apostrophe-free colorway name); the src is the crop at its native width, and the
  // srcset is rebuilt here with the section's srcset_dd_widths below that width.
  const DD_WIDTHS = [480, 720, 960, 1200, 1400];
  const evaMapEl = document.querySelector("[data-loonr-eva-photos]");
  let evaPhotos = {};
  if (evaMapEl) { try { evaPhotos = JSON.parse(evaMapEl.textContent) || {}; } catch (e) { evaPhotos = {}; } }
  const evaImg = document.querySelector("[data-eva-photo]");
  function evaSrcset(src) {
    const m = /[?&]width=(\d+)/.exec(src || "");
    if (!m) return "";
    const max = parseInt(m[1], 10);
    const parts = DD_WIDTHS.filter(w => w < max).map(w => src.replace(/([?&]width=)\d+/, "$1" + w) + " " + w + "w");
    parts.push(src + " " + max + "w");
    return parts.join(", ");
  }
  function swapEvaPhoto(colorName) {
    if (!evaImg) return;
    const p = evaPhotos[normalizeColorName(colorName)];
    if (!p || !p.src || evaImg.getAttribute("src") === p.src) return;
    const set = evaSrcset(p.src);
    if (set) evaImg.setAttribute("srcset", set); else evaImg.removeAttribute("srcset");
    evaImg.setAttribute("src", p.src);
    if (p.alt) evaImg.alt = p.alt;
  }

  // ── State ─────────────────────────────────────────────────
  let currentVariant = variants.find(v => v.id === config.currentVariantId) || variants[0];
  // No size preset (Round 5 P0-3, Mike 2026-09-30). Only a ?variant= link arrives with a
  // size; otherwise both buy buttons read "Choose your size" until the shopper picks one
  // (see applySizeGate + the inline handler under the sticky bar in main-product-loonr.liquid).
  // currentVariant still holds the colorway's first variant for photos, price and ship window.
  // An older cached page without the flag keeps the old behaviour.
  let sizeChosen = config.sizeChosen !== false;
  // Size-label unit the shopper picked (US Women / US Men), null until they tap one. A
  // swatch tap rebuilds the size options in unisex codes, so commitColor() re-applies it
  // (Round 5 P2: the placeholder said "US Men" over "M4/W5" options).
  let activeUnit = (document.querySelector(".unit-toggle button.active") || {}).dataset?.unit || null;

  function findVariant(color, size) {
    return variants.find(v =>
      (colorIndex < 0 || v.options[colorIndex] === color) &&
      (sizeIndex  < 0 || v.options[sizeIndex]  === size)
    );
  }

  function updateUrl(variantId) {
    const url = new URL(window.location);
    // No ?variant= until a size is chosen: a shared or reloaded link would otherwise
    // arrive with a size the shopper never picked.
    if (sizeChosen) url.searchParams.set("variant", variantId);
    else url.searchParams.delete("variant");
    window.history.replaceState({}, "", url);
  }

  function paintSizeOptions(color) {
    if (!sizeSelect) return;
    // Re-render size options for the active color, preserving the selected size if available.
    const previouslySelected = sizeSelect.value;
    const placeholder = sizeSelect.querySelector("option[disabled]");
    sizeSelect.innerHTML = "";
    if (placeholder) sizeSelect.appendChild(placeholder);
    variants
      .filter(v => v.options[colorIndex] === color)
      .forEach(v => {
        const opt = document.createElement("option");
        const size = v.options[sizeIndex];
        opt.value = size;
        opt.dataset.variantId = v.id;
        opt.dataset.available = v.available;
        const _vs = variantState(v);
        opt.dataset.stock = _vs === "instock" ? "In stock" : _vs === "preorder" ? (shipsNow(color) ? "" : "Pre-order") : "Sold out";
        // Mike 10/17: no "Available" label; only Pre-order / In stock / Sold out print.
        opt.textContent = opt.dataset.stock ? `${size} · ${opt.dataset.stock}` : size;
        if (size === previouslySelected) opt.selected = true;
        sizeSelect.appendChild(opt);
      });
  }

  // Three-way buy state. With "continue selling" on, variant.available is true
  // even at zero stock, so we key off inventory + purchasability. NOTE: pre-order
  // is now inventory-driven, NOT selling-plan-driven — the pre-order selling plan
  // was dropped so discount codes (incl. Buy-X-Get-Y) apply to these carts. A
  // zero-stock line that is still purchasable (continue-selling/oversold) is a
  // pre-order; a DENY / unordered SKU reports available:false and stays sold out.
  //   instock  = real stock on hand                     -> Add to cart
  //   preorder = zero stock, still purchasable (oversell) -> Add to cart (Pre-order) (+ notify-when-ships)
  //   soldout  = zero stock, not purchasable/unordered   -> Holler when it's back (notify-me)
  function variantState(v) {
    if (!v) return "unavailable";
    const tracked = typeof v.inv === "number";
    if (tracked ? v.inv > 0 : v.available) return "instock";
    if (UNORDERED_SKUS.has(v.sku)) return "soldout"; // ordered 0 -> notify-me, never pre-order
    if (v.available) return "preorder"; // oversold / continue-selling => pre-orderable
    return "soldout";
  }

  // Keep the hidden line-item PROPERTY "Ships" in step with the variant, so a
  // pre-order add-to-cart carries a note that renders natively in cart, checkout,
  // order, and the order confirmation email. This REPLACES the old selling_plan
  // input: the pre-order selling plan was dropped so discount codes (incl.
  // Buy-X-Get-Y) apply to these carts as plain one-time purchases. Also strips any
  // stale selling_plan input.
  // Round 5 P1-1: the input is now server-rendered in main-product-loonr.liquid
  // ([data-ships-input], disabled unless the page loaded on a pre-order variant), so
  // a tap before this script runs still carries it. We REUSE that one input and flip
  // `disabled` (a disabled input is not submitted) instead of adding/removing nodes,
  // and drop any extra copy, so the cart can never get two Ships values.
  function ensurePreorderProperty(isPreorder) {
    const form = document.getElementById("product-form-loonr");
    if (!form) return;
    const stalePlan = form.querySelector('input[name="selling_plan"]');
    if (stalePlan) stalePlan.remove();
    // An add-to-cart that serializes inputs itself can pick up a disabled one, so an unused
    // Ships input also loses its name (no empty "Ships" on C1/C2 lines, 10/17).
    const found = form.querySelectorAll('input[name="properties[Ships]"], input[data-ships-input]');
    for (let i = 1; i < found.length; i++) found[i].remove();
    let input = found[0] || null;
    if (!input) {
      if (!isPreorder) return;
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[Ships]";
      form.appendChild(input);
    }
    if (isPreorder && currentVariant) {
      input.value = shipLabel(currentVariant.options[colorIndex]); // per-color window (e.g. "late Oct")
      input.name = "properties[Ships]";
      input.disabled = false;
    } else {
      input.disabled = true;
      input.removeAttribute("name");
    }
  }

  // Only write when the text actually changes. The buy labels are server-rendered
  // now (P1-1), so on load this is usually a no-op, and rewriting identical text in
  // an aria-live region can make a screen reader announce it again.
  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function syncAtcButton() {
    if (!atc) return;
    // Sticky mobile ATC bar — mirrors main button state. May be absent on
    // pages that don't render the sticky bar (e.g., older previews).
    const stickyBtn = document.querySelector("[data-sticky-atc-btn]");
    const stickyLabel = document.querySelector("[data-sticky-atc-label]");
    const stickyPrice = document.querySelector("[data-sticky-price]");
    if (!currentVariant) {
      atc.disabled = true;
      setText(atc.querySelector("[data-atc-label]"), "Unavailable");
      if (stickyBtn) { stickyBtn.disabled = true; }
      setText(stickyLabel, "Unavailable");
      ensurePreorderProperty(false);
      return;
    }
    atc.disabled = false;
    if (stickyBtn) stickyBtn.disabled = false;
    const labelEl = atc.querySelector("[data-atc-label]");
    const rawState = variantState(currentVariant);
    // A zero-stock C1/C2 color is sold as shipping now: buys like in stock, keeps the Ships property.
    const shipNowColor = rawState === "preorder" && shipsNow(currentVariant.options[colorIndex]);
    const state = shipNowColor ? "instock" : rawState;
    const preorderShipNow = shipFor(currentVariant.options[colorIndex]);
    atc.classList.remove("oos", "preorder");
    if (stickyBtn) stickyBtn.classList.remove("oos", "preorder");
    if (state === "instock") {
      setText(labelEl, "Add to cart"); // Mike 10/17: price sits above, not on the button
      setText(stickyLabel, "Add to cart");
    } else if (state === "preorder") {
      atc.classList.add("preorder");
      // Mike 2026-09-20: the button names the ACTION ("Pre-order · Ships mid Oct" read
      // like an announcement). The ship window stays right above it (price row) and
      // right below it (charge note), both retexted per colorway further down.
      // The sticky bar is too narrow for the full label, so it reads plain "Add to cart"
      // (Mike 2026-09-30; "Pre-order" from 9/20): the pre-order status is on the main
      // button, the price row and the charge note. Same labels are server-rendered
      // (main-product-loonr.liquid, cv_state).
      setText(labelEl, "Add to cart (Pre-order)");
      setText(stickyLabel, "Add to cart");
      if (stickyBtn) stickyBtn.classList.add("preorder");
    } else {
      atc.classList.add("oos");
      setText(labelEl, "Holler when it's back");
      setText(stickyLabel, "Holler when it's back");
      if (stickyBtn) stickyBtn.classList.add("oos");
    }
    // The Ships property follows the variant (enabled + per-color value on a
    // pre-order, disabled otherwise), whichever button ends up submitting the form.
    ensurePreorderProperty(state === "preorder" || (shipNowColor && !!SHIP_NOW));
    // Secondary "Holler when it ships" shows only on pre-order variants.
    const preorderNotify = document.querySelector("[data-preorder-notify]");
    if (preorderNotify) preorderNotify.hidden = state !== "preorder";
    // Charge-timing note ("This color ships late Oct. Pay now ... Cancel anytime
    // before it ships."), same gate: pre-order variants only. Server-rendered copy
    // and visibility; JS retexts the per-colorway window and shows/hides it.
    const preorderNote = document.querySelector("[data-preorder-note]");
    if (preorderNote) {
      preorderNote.hidden = state !== "preorder";
      setText(preorderNote.querySelector("strong"), `This color ships ${preorderShipNow}.`);
    }
    // First-screen ship window on the price row (main-product-loonr.liquid).
    // Pre-order only: retexts per colorway and hides itself once stock lands.
    const shipWindow = document.querySelector("[data-ship-window]");
    if (shipWindow) {
      shipWindow.hidden = !(state === "preorder" || (shipNowColor && !!SHIP_NOW));
      // Mike 10/17: two lines, "This color" over "Ships mid Nov"; only the second line changes.
      const shipText = shipWindow.querySelector("[data-ship-window-text]");
      if (shipText) setText(shipText, `ships ${preorderShipNow}`); else setText(shipWindow, `Ships ${preorderShipNow}`);
    }
    if (priceEl) priceEl.textContent = currentVariant.price;
    if (stickyPrice) stickyPrice.textContent = currentVariant.price;
    if (skuEl) skuEl.textContent = currentVariant.sku || "";
    if (variantIdInput) variantIdInput.value = currentVariant.id;
    applySpecs(currentVariant);
    applySizeGate();
  }

  // Round 5 P0-3: until a size is chosen, both buttons are a live "Choose your size" that
  // jumps to the picker (the inline handler keys off data-needs-size) and can never submit:
  // type=button, and the id input is disabled. Picking a size restores the states above.
  function applySizeGate() {
    const stickyBtn = document.querySelector("[data-sticky-atc-btn]");
    const stickyLabel = document.querySelector("[data-sticky-atc-label]");
    const buttons = [atc, stickyBtn].filter(Boolean);
    if (!sizeChosen) {
      buttons.forEach(b => {
        b.type = "button";
        b.disabled = false;
        b.setAttribute("data-needs-size", "");
        b.classList.remove("oos", "preorder");
        b.classList.add("needs-size");
      });
      atc.removeAttribute("data-oos");
      setText(atc.querySelector("[data-atc-label]"), "Choose your size");
      setText(stickyLabel, "Choose your size");
      if (variantIdInput) variantIdInput.disabled = true;
      return;
    }
    buttons.forEach(b => {
      b.type = "submit";
      b.removeAttribute("data-needs-size");
      b.classList.remove("needs-size");
    });
    if (variantIdInput) variantIdInput.disabled = false;
  }

  // Cap visible non-hero gallery cells per color, so a color with a lot of
  // lifestyle shots doesn't bury the studio angles. The 6 studio product shots
  // (45/90/180/225/Back/Sole) are RESERVED inside the cap so the sole/back can't
  // get pushed out by better-scored lifestyle; lifestyle fills the rest. Hero is
  // a separate slot (no data-color), not counted: cap 10 + hero = 11 max/color.
  const GALLERY_CAP = 10;
  // Desktop grid shows the hero + this many supporting shots (Mike 2026-08-19:
  // "hero image plus 8 below"). The overflow is NOT dropped — it stays in the
  // mobile swipe carousel and in the zoom viewer, and is hidden in the desktop
  // grid only, via [data-desk-hidden] + a >=990px CSS rule.
  const DESKTOP_GRID_CAP = 8;
  // A studio product shot, e.g. HF_BLU_225_7.jpg / LR_TEA_Sole_2.jpg. On-model
  // files (Lifestyle/Outdoor/Plume/Snow) are never treated as product shots.
  const PRODUCT_SHOT_RE = /_(?:45|90|180|225|Back|Sole)_\d+\./i;
  function isProductShot(el) {
    const img = el.querySelector("img");
    if (!img) return false;
    const src = img.src || "";
    if (/Lifestyle|Outdoor|Plume|Snow/i.test(src)) return false;
    return PRODUCT_SHOT_RE.test(src);
  }

  function filterGalleryByColor(colorName) {
    const normalized = normalizeColorName(colorName);
    const figures = document.querySelectorAll(".gallery .shot[data-color]");
    // Whatever image is currently in the hero slot must not also appear as a
    // gallery thumbnail. The hero is chosen by color-matched scoring (server)
    // or first-color-match (JS), so it usually isn't the variant's
    // featured_media — without this guard the hero photo repeats as the first
    // thumbnail. All srcs come from image_url:width:1400, so an exact-string
    // compare is reliable.
    const heroSrc = heroImg ? heroImg.src : null;
    // First pass: pre-hide non-matching + the hero duplicate, collect matching.
    const visible = [];
    figures.forEach(el => {
      const c = el.dataset.color;
      const matches = (c === "" || c === normalized);
      const img = el.querySelector("img");
      const isHeroDup = heroSrc && img && img.src === heroSrc;
      if (matches && !isHeroDup) visible.push(el);
      else el.hidden = true;
    });
    // Sort matching by CSS `order` value (lower = appears first / better score).
    visible.sort((a, b) => {
      const oa = parseInt(a.style.order || "0", 10);
      const ob = parseInt(b.style.order || "0", 10);
      return oa - ob;
    });
    // Reserve product shots first (guaranteed inside the cap), then fill the
    // remaining slots with lifestyle in score order. Visual order is unchanged
    // (CSS `order`), so the lifestyle hero still leads and the sole stays last —
    // it just can no longer fall off the end.
    const keep = new Set();
    for (const el of visible) {
      if (isProductShot(el) && keep.size < GALLERY_CAP) keep.add(el);
    }
    for (const el of visible) {
      if (keep.size >= GALLERY_CAP) break;
      keep.add(el);
    }
    visible.forEach(el => {
      el.hidden = !keep.has(el);
      // Revealed cells get their srcset before their lazy load can start.
      if (!el.hidden) ensureShotSrcset(el.querySelector("img"));
    });
    // Mark the desktop-grid overflow. `visible` is already sorted by CSS `order`,
    // so this counts in the order the shopper actually sees them.
    let shown = 0;
    for (const el of visible) {
      if (el.hidden) continue;
      shown += 1;
      if (shown > DESKTOP_GRID_CAP) el.setAttribute("data-desk-hidden", "");
      else el.removeAttribute("data-desk-hidden");
    }
  }

  // ── Gallery carousel dots (mobile) ────────────────────────
  // One <button> per visible .shot. Rebuilt on color change because the
  // visible-shot count varies per colorway (filename-based filter). Active
  // dot tracked by a scroll listener that picks the slide whose horizontal
  // center is closest to the gallery's viewport center.

  // Visible shots in VISUAL order (what the carousel actually renders L→R),
  // NOT DOM order. The liquid sets inline `style="order: N"` on each .shot —
  // hero is -100, well-scored angles negative, sole/back shots positive — so
  // DOM order ≠ scroll order. Without this sort the dots light up in DOM
  // order while the user swipes in visual order, hopping 1 → 4 → 5 → 2 → 3.
  function getOrderedVisibleShots(gallery) {
    return Array.from(gallery.querySelectorAll(".shot:not([hidden])"))
      .sort((a, b) => {
        const oa = parseInt(a.style.order || "0", 10);
        const ob = parseInt(b.style.order || "0", 10);
        return oa - ob;
      });
  }

  function buildGalleryDots() {
    const gallery = document.querySelector(".loonr-pdp .gallery");
    const dotsEl = document.querySelector("[data-gallery-dots]");
    if (!gallery || !dotsEl) return;
    const visible = getOrderedVisibleShots(gallery);
    dotsEl.innerHTML = "";
    visible.forEach((shot, i) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "gallery-dot" + (i === 0 ? " is-active" : "");
      btn.setAttribute("aria-label", `Go to image ${i + 1} of ${visible.length}`);
      btn.addEventListener("click", () => {
        shot.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
      });
      dotsEl.appendChild(btn);
    });
  }

  function updateActiveDot() {
    const gallery = document.querySelector(".loonr-pdp .gallery");
    const dotsEl = document.querySelector("[data-gallery-dots]");
    if (!gallery || !dotsEl) return;
    const visible = getOrderedVisibleShots(gallery);
    if (!visible.length) return;
    const rect = gallery.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    let bestIdx = 0;
    let bestDist = Infinity;
    visible.forEach((shot, i) => {
      const r = shot.getBoundingClientRect();
      const shotCenter = r.left + r.width / 2;
      const dist = Math.abs(shotCenter - centerX);
      if (dist < bestDist) { bestDist = dist; bestIdx = i; }
    });
    const dots = dotsEl.querySelectorAll(".gallery-dot");
    dots.forEach((d, i) => d.classList.toggle("is-active", i === bestIdx));
  }

  let galleryScrollAttached = false;
  function attachGalleryScroll() {
    if (galleryScrollAttached) return;
    const gallery = document.querySelector(".loonr-pdp .gallery");
    if (!gallery) return;
    let raf = 0;
    gallery.addEventListener("scroll", () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        updateActiveDot();
        raf = 0;
      });
    }, { passive: true });
    galleryScrollAttached = true;
  }

  // Loop wrap on edge-swipe: if user is at the last slide and swipes left
  // (wanting "next"), jump to slide 0. If at slide 0 and swipes right
  // (wanting "prev"), jump to the last slide. Touch-event based.
  //
  // Sensitivity tuning (May '26 pass): threshold 18px so a gentle swipe
  // counts; edge tolerance 30px so a swipe that starts mid-snap-animation
  // still registers as "at the edge"; checks BOTH touchstart and touchend
  // scrollLeft. wasStuck guard (scrollDelta < 40) prevents a hard mid-
  // carousel swipe that lands at the edge from triggering wrap on arrival.
  let galleryEdgeWrapAttached = false;
  function attachGalleryEdgeWrap() {
    if (galleryEdgeWrapAttached) return;
    const gallery = document.querySelector(".loonr-pdp .gallery");
    if (!gallery) return;
    let touchStartX = null;
    let touchStartScrollLeft = null;
    const SWIPE_THRESHOLD = 18;
    const EDGE_TOLERANCE  = 30;
    gallery.addEventListener("touchstart", (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartScrollLeft = gallery.scrollLeft;
    }, { passive: true });
    gallery.addEventListener("touchend", (e) => {
      if (touchStartX === null) return;
      const dx = e.changedTouches[0].clientX - touchStartX;
      const maxScroll = gallery.scrollWidth - gallery.clientWidth;
      const scrollDelta = Math.abs(gallery.scrollLeft - touchStartScrollLeft);
      const wasStuck = scrollDelta < 40; // gallery barely moved → user was at edge
      const atRightEdge = (touchStartScrollLeft >= maxScroll - EDGE_TOLERANCE)
                       || (gallery.scrollLeft   >= maxScroll - EDGE_TOLERANCE);
      const atLeftEdge  = (touchStartScrollLeft <= EDGE_TOLERANCE)
                       || (gallery.scrollLeft   <= EDGE_TOLERANCE);
      // At right edge, swiped left (wanted next) → wrap to start.
      if (wasStuck && atRightEdge && dx < -SWIPE_THRESHOLD) {
        gallery.scrollTo({ left: 0, behavior: "smooth" });
      }
      // At left edge, swiped right (wanted prev) → wrap to end.
      else if (wasStuck && atLeftEdge && dx > SWIPE_THRESHOLD) {
        gallery.scrollTo({ left: maxScroll, behavior: "smooth" });
      }
      touchStartX = null;
      touchStartScrollLeft = null;
    }, { passive: true });
    galleryEdgeWrapAttached = true;
  }

  // Sticky ATC reveal (Merry People pattern): hidden until the user has
  // scrolled the in-flow #atc-loonr button so its BOTTOM crosses above
  // the midline of the viewport — i.e., they're actively past the main
  // CTA. Earlier than waiting for "fully scrolled off the top" so there's
  // no dead zone between the in-flow ATC fading and the sticky sliding
  // up. Below-viewport (user hasn't reached the ATC yet) stays hidden.
  let stickyAtcRevealAttached = false;
  function attachStickyAtcReveal() {
    if (stickyAtcRevealAttached) return;
    const stickyBar = document.querySelector("[data-sticky-atc]");
    const mainAtc = document.getElementById("atc-loonr");
    if (!stickyBar || !mainAtc) return;

    // Mike 10/17: one Add to cart on screen at a time. The bar shows whenever the main button
    // is out of sight (not reached yet, or scrolled up under the header) and hides while it shows.
    function evaluate() {
      const rect = mainAtc.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      const header = document.querySelector("sticky-header, .header-wrapper");
      const topEdge = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const barH = stickyBar.offsetHeight || 0;
      const mainOnScreen = rect.bottom > topEdge && rect.top < vh - barH;
      stickyBar.classList.toggle("is-visible", !mainOnScreen);
    }

    let raf = 0;
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(() => { evaluate(); raf = 0; });
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", evaluate, { passive: true });
    evaluate();
    stickyAtcRevealAttached = true;
  }

  // Rec. 601 luminance. Now only decides the subhead's rescue outline for a light
  // colorway with no darkened override. It USED to pick the unit pill's text color
  // too, and its 0.55 cut put paper text on teal (luma 0.52): 2.26:1 on the default
  // colorway. The pill reads the color-pass field pair instead (Round 5 P1-21, see
  // .unit-toggle button.active in pdp-loonr.css).
  function isLightColor(hex) {
    const r = parseInt(hex.substring(1, 3), 16);
    const g = parseInt(hex.substring(3, 5), 16);
    const b = parseInt(hex.substring(5, 7), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.55;
  }

  // The cheap, first-screen part of a colorway change: the colorway name's color in
  // the title and the hero card's backdrop tint. Split out of applyColorAccent so a
  // swatch tap can paint it before the heavy work (P1-6b); applyColorAccent still
  // runs it, so every caller gets the same end state.
  function applySubheadAccent(colorName) {
    const hex = colorAccentMap[colorName] || "#2D2926";
    const key = colorKey(colorName);
    if (subheadEm) {
      // The subhead em uses a DARKENED hex for low-contrast colorways (yellow,
      // orange, teal, white) — see subheadDarkMap. Other colors use the original
      // boot hex. This way the boot photo + swatch + dot + pill still pop with
      // the bright brand color, but the colorway name reads cleanly on cream.
      subheadEm.style.color = subheadDarkMap[colorName] || hex;
      subheadEm.dataset.colorKey = key;
      // Outline was a rescue for bright-fill low-contrast text. Now that
      // subheadDarkMap supplies a contrast-safe darkened color, the 1.5px ink
      // stroke makes the italic serif letterforms feel fuzzy/halo'd. We only
      // keep the outline as future-proofing: if a NEW light colorway lands
      // without a darkened-map entry, the outline still kicks in as a rescue.
      const hasDarkOverride = Object.prototype.hasOwnProperty.call(subheadDarkMap, colorName);
      subheadEm.classList.toggle("needs-outline", isLightColor(hex) && !hasDarkOverride);
    }
    // Mirror the same color key onto the hero figure so the card backdrop
    // tint swaps in sync with the boot. CSS reads .shot-hero[data-color-key]
    // and applies the matching desaturated wash.
    const heroFigure = document.querySelector("[data-hero-slot]");
    if (heroFigure) heroFigure.dataset.colorKey = key;
  }

  function applyColorAccent(colorName) {
    const hex = colorAccentMap[colorName] || "#2D2926";
    applySubheadAccent(colorName);
    // Set --swatch-accent on the PDP root so any component can inherit it (the
    // active gallery pagination dot). White (Frosty's Flake) falls back to ink for
    // legibility on light backgrounds. The US Women / US Men pill no longer uses
    // it: it reads --cw-field / --cw-field-text below, the AA-tuned field pair.
    const root = document.querySelector(".loonr-pdp");
    if (root) {
      const accent = hex === "#FFFFFF" ? "#2D2926" : hex;
      root.style.setProperty("--swatch-accent", accent);
      const f = colorFieldMap[colorName];
      if (f) {
        root.style.setProperty("--cw-field", f[0]);
        root.style.setProperty("--cw-field-text", f[1]);
        root.style.setProperty("--cw-field-shadow", f[2]);
        root.style.setProperty("--cw-second", f[3]);
        root.style.setProperty("--cw-second-text", f[4]);
        root.style.setProperty("--cw-shelf", f[5]);
      }
    }
  }

  // Swap hero img. Prefer a color-matched gallery shot (filename-derived
  // data-color) over variant.featured_media_url: if a variant has its
  // featured_media misconfigured to a wrong-color photo in Shopify, this
  // priority guarantees the hero always matches the selected colorway.
  // Falls back to v.featured_media_url if no color-matched shot exists.
  // Idempotent (no write when the src is already right), so the swatch preview
  // and applyVariant can both call it.
  function swapHero(color, v) {
    if (!heroImg) return;
    const normalized = normalizeColorName(color);
    // Prefer the 225 front three-quarter (the F26 hero angle) for this color, to
    // match the server-side hero pick; fall back to the first color-matched shot,
    // then variant.featured_media.
    const colorShots = document.querySelectorAll(`.gallery .shot[data-color="${CSS.escape(normalized)}"] img`);
    let matched = null;
    for (const img of colorShots) { if (img.src && img.src.indexOf("_225_") !== -1) { matched = img; break; } }
    const fm = v ? v.featured_media_url : "";
    let next = "";
    // The DEFAULT color's 225 is the server-rendered hero, and the Liquid
    // gallery loop skips the variant's featured_media, so that shot never has
    // a gallery cell. Tapping away and back to the default color used to fall
    // through to its first lifestyle shot (seen 2026-09-16 with the teal
    // default; the same thing happened with black before). When no 225 cell
    // exists, prefer the variant's own featured media if it is the 225 angle.
    if (!matched && fm && fm.indexOf("_225_") !== -1) {
      next = fm;
    } else {
      if (!matched && colorShots.length) matched = colorShots[0];
      if (matched && matched.src) {
        next = matched.src;
      } else if (fm) {
        next = fm;
      }
    }
    if (next && heroImg.getAttribute("src") !== next && heroImg.src !== next) {
      // srcset wins over src, so the new photo needs its own srcset (same widths as the
      // server-rendered one) or the old colorway would stay on screen.
      const set = srcsetFrom(next, HERO_WIDTHS);
      if (set) heroImg.setAttribute("srcset", set); else heroImg.removeAttribute("srcset");
      heroImg.src = next;
    }
  }

  function applyVariant(v) {
    if (!v) return;
    currentVariant = v;
    updateUrl(v.id);
    syncAtcButton();
    const color = v.options[colorIndex];
    colorNameEls.forEach(el => { setText(el, color); });
    setText(colorPickerName, color);
    swapHero(color, v);
    // Filter the rest of the gallery to images tagged to this color.
    filterGalleryByColor(color);
    // Rebuild carousel dots to match the new visible-shot count and reset
    // the scroll position to the hero so the new colorway starts at slide 0.
    buildGalleryDots();
    const galleryEl = document.querySelector(".loonr-pdp .gallery");
    if (galleryEl) galleryEl.scrollLeft = 0;
    // Update the subheadline color to match the boot.
    applyColorAccent(color);
    // The foam band's photo follows the colorway, like the band behind it.
    swapEvaPhoto(color);
    // Update the new/refreshed/classic stamps for this colorway.
    applyColorStatus(color);
    // Swap the Description accordion lead to this colorway's copy.
    applyColorwayDesc(color);
  }

  // ── Color swatch click ────────────────────────────────────
  // INP (Round 5 P1-6b; Lo Rider mobile field INP p75 213 ms). A tap used to run
  // everything before the browser could paint: size options, variant + URL + buy
  // state, the gallery re-filter over ~130 figures, dots, accents, stamps, copy.
  // Now the tap paints what the shopper touched (swatch ring, colorway name and
  // its color, hero photo), lets that frame reach the screen, THEN does the rest.
  // INP ends at that first paint. The end state is exactly what it was.
  // A newer tap supersedes an older one still waiting, and anything that reads
  // the variant (both buy buttons, the size select, the unit toggle, notify-me)
  // flushes a waiting update first, so nothing ever acts on a stale variant.

  // Resolve after the browser has put the current frame on screen: a rAF callback
  // runs just before the next paint, and a task queued from inside it runs just
  // after. scheduler.yield() where the browser has it, else setTimeout(0). A hidden
  // tab never runs rAF, so don't wait on it there.
  function afterNextPaint() {
    return new Promise(resolve => {
      if (document.visibilityState === "hidden") { setTimeout(resolve, 0); return; }
      requestAnimationFrame(() => {
        if (window.scheduler && typeof window.scheduler.yield === "function") {
          window.scheduler.yield().then(resolve, resolve);
        } else {
          setTimeout(resolve, 0);
        }
      });
    });
  }

  function colorTarget(newColor) {
    const currentSize = sizeSelect ? sizeSelect.value : null;
    return findVariant(newColor, currentSize) ||
           variants.find(v => v.options[colorIndex] === newColor && v.available) ||
           variants.find(v => v.options[colorIndex] === newColor);
  }

  // The heavy part, unchanged from the old click handler: repaint size options for
  // the new color, then choose a variant and apply it.
  function commitColor(newColor) {
    paintSizeOptions(newColor);
    // paintSizeOptions writes unisex codes ("M4/W5"); keep the unit the shopper picked.
    if (activeUnit) repaintSizeLabels(activeUnit);
    const target = colorTarget(newColor);
    if (target && sizeSelect) {
      // Before a size is chosen the placeholder stays up; the colorway still changes.
      if (sizeChosen) sizeSelect.value = target.options[sizeIndex];
      else sizeSelect.selectedIndex = 0;
    }
    applyVariant(target);
  }

  let pendingColor = null; // tapped color whose heavy update hasn't run yet
  let colorSeq = 0;
  function flushPendingColor() {
    if (pendingColor === null) return;
    const c = pendingColor;
    pendingColor = null;
    colorSeq++; // the scheduled run for it becomes a no-op
    commitColor(c);
  }

  swatches.forEach(s => {
    s.addEventListener("click", () => {
      const newColor = s.dataset.optionValue;
      swatches.forEach(x => {
        const on = x === s;
        x.classList.toggle("active", on);
        x.setAttribute("aria-pressed", on ? "true" : "false");
      });
      // Paint first: what was tapped, cheaply.
      colorNameEls.forEach(el => { setText(el, newColor); });
      setText(colorPickerName, newColor);
      applySubheadAccent(newColor);
      swapHero(newColor, colorTarget(newColor));
      // Then everything else, after that frame is on screen.
      pendingColor = newColor;
      const seq = ++colorSeq;
      afterNextPaint().then(() => {
        if (seq !== colorSeq || pendingColor === null) return; // superseded or flushed
        const c = pendingColor;
        pendingColor = null;
        commitColor(c);
      });
    });
  });

  // ── Size select change ────────────────────────────────────
  if (sizeSelect) {
    sizeSelect.addEventListener("change", () => {
      flushPendingColor(); // options must belong to the tapped color first
      const opt = sizeSelect.options[sizeSelect.selectedIndex];
      // No optional chaining: `opt?.` is a parse error on iOS Safari < 13.4, which
      // fails the WHOLE file and breaks the custom PDP for those users. Plain guard
      // is behaviourally identical and parses everywhere.
      const vid = (opt && opt.dataset.variantId) ? parseInt(opt.dataset.variantId, 10) : null;
      const target = variants.find(v => v.id === vid);
      if (target) sizeChosen = true; // Round 5 P0-3: the buttons become real from here on
      applyVariant(target);
    });
  }

  // ── Unit toggle (display-only translation of unisex codes) ─
  const unitButtons = document.querySelectorAll(".unit-toggle button");
  // Map unisex M/W code to per-unit label (rough; refine when needed).
  const unitLabels = {
    // Mike 10/17: numbers only once US Women / US Men is picked (the toggle already says which).
    "us-w":  s => { const m = s.match(/\/W?(\d+)$/); return m ? m[1] : s; },   // M4/W5 -> 5, M12/13 -> 13
    // Men's dual sizes keep both numbers (Mike 10/17): M12/13 -> 12/13, M14/15 -> 14/15.
    "us-m":  s => /\/W/.test(s) ? s.replace(/^M(\d+)\/W\d+$/, "$1") : s.replace(/^M/, ""),   // M4/W5 -> 4
    "eu":    s => ({
      "M4/W5": "EU 36", "M5/W6": "EU 37", "M6/W7": "EU 38", "M7/W8": "EU 39",
      "M8/W9": "EU 40", "M9/W10": "EU 41", "M10/W11": "EU 42", "M11/W12": "EU 43",
      "M12/13": "EU 44", "M14/15": "EU 46"
    }[s] || s),
    "cm":    s => ({
      "M4/W5": "23.0 cm", "M5/W6": "24.0 cm", "M6/W7": "25.0 cm", "M7/W8": "25.5 cm",
      "M8/W9": "26.0 cm", "M9/W10": "27.0 cm", "M10/W11": "28.0 cm", "M11/W12": "28.5 cm",
      "M12/13": "29.5 cm", "M14/15": "31.0 cm"
    }[s] || s),
  };

  // Mike 10/17: no women's 15. M14/15 is offered under US Men (and EU/CM) only; under US Women
  // the option is taken out of the list (iOS ignores hidden <option>s, so it is detached, not hidden).
  const WOMEN_HIDDEN = "M14/15";
  let stashedOpt = null;
  function repaintSizeLabels(unit) {
    if (!sizeSelect) return;
    const fn = unitLabels[unit] || unitLabels["us-w"];
    const big = Array.from(sizeSelect.options).find(o => o.value === WOMEN_HIDDEN);
    if (unit === "us-w") {
      if (big && !big.selected) { stashedOpt = big; big.remove(); }
    } else if (!big && stashedOpt && stashedOpt.dataset.variantId &&
               variants.some(v => String(v.id) === stashedOpt.dataset.variantId &&
                 (colorIndex < 0 || v.options[colorIndex] === (currentVariant ? currentVariant.options[colorIndex] : null)))) {
      sizeSelect.appendChild(stashedOpt);
      stashedOpt = null;
    }
    Array.from(sizeSelect.options).forEach(opt => {
      if (opt.disabled) {
        opt.textContent = `Select size (${unit === "us-w" ? "US Women" : unit === "us-m" ? "US Men" : unit.toUpperCase()})`;
        return;
      }
      const baseSize = opt.value; // The variant key stays the unisex code
      const display = fn(baseSize);
      opt.textContent = opt.dataset.stock ? `${display} · ${opt.dataset.stock}` : display;
    });
  }

  unitButtons.forEach(b => {
    b.addEventListener("click", () => {
      flushPendingColor();
      unitButtons.forEach(x => {
        x.classList.remove("active");
        x.setAttribute("aria-selected", "false");
      });
      b.classList.add("active");
      b.setAttribute("aria-selected", "true");
      activeUnit = b.dataset.unit;
      repaintSizeLabels(activeUnit);
    });
  });

  // Size-unit preference stays per-page (no sessionStorage, per the project rule).
  // Numbers-only labels from first paint (Mike 10/17), in the unit the toggle shows as active.
  if (activeUnit) repaintSizeLabels(activeUnit);

  // ── Notify-me capture (back-in-stock) ─────────────────────
  // Reveals the inline Klaviyo email capture. Shared by BOTH the sold-out primary
  // button and the "We'll holler" pre-order secondary. (Stoq is uninstalled;
  // notify-me is entirely our own Klaviyo capture — see fireKlaviyoNotify below.
  // The submit reads currentVariant, so the captured event stays variant-specific.)
  function openNotifyCapture() {
    const form = document.querySelector("[data-preorder-notify-form]");
    if (!form) return;
    form.hidden = false;
    const secondary = document.querySelector("[data-preorder-notify]");
    if (secondary) secondary.hidden = true;
    const email = form.querySelector("[data-notify-email]");
    if (email) email.focus();
  }

  // ── ATC submit handling ───────────────────────────────────
  if (atc) {
    atc.addEventListener("click", (e) => {
      flushPendingColor(); // a tap right after a swatch tap buys the tapped color
      // No size yet: the inline handler jumps to the picker; nothing is added.
      if (!sizeChosen) { e.preventDefault(); return; }
      if (!currentVariant) {
        e.preventDefault();
        return;
      }
      const state = variantState(currentVariant);
      if (state === "preorder") {
        // Add to cart with the "Ships" line-item property, then submit naturally. A C1/C2 color
        // in ship-now mode with an empty phrase sends no Ships at all (10/17).
        ensurePreorderProperty(needsShipsProp(currentVariant));
        return;
      }
      if (state === "soldout") {
        // Sold out -> open our Klaviyo notify-me capture instead of adding.
        e.preventDefault();
        openNotifyCapture();
        return;
      }
      // In stock -> normal add to cart (clear any stale pre-order property).
      ensurePreorderProperty(false);
    });
  }

  // Sticky mobile button mirrors the main ATC: when the selected variant is
  // sold out it triggers Stoq notify-me instead of submitting an unavailable
  // variant to the product form.
  const stickyAtcBtn = document.querySelector("[data-sticky-atc-btn]");
  if (stickyAtcBtn) {
    stickyAtcBtn.addEventListener("click", (e) => {
      flushPendingColor();
      if (!sizeChosen) { e.preventDefault(); return; }
      if (!currentVariant) { e.preventDefault(); return; }
      const state = variantState(currentVariant);
      if (state === "preorder") {
        ensurePreorderProperty(needsShipsProp(currentVariant));
        return;
      }
      if (state === "soldout") {
        e.preventDefault();
        openNotifyCapture();
        return;
      }
      ensurePreorderProperty(false);
    });
  }

  // Secondary pre-order CTA: "We'll holler when they're back in stock."
  // Stoq can't notify-me on a pre-order (it reads as "available"), so we capture
  // the lead ourselves in Klaviyo via the onsite object: identify the email +
  // fire a product-tagged "Notify Me Requested" event. Inline email field (no
  // popup), email-first (no live SMS). Fails soft + tells the shopper if Klaviyo
  // isn't reachable instead of silently eating the click.
  const preorderNotifyBtn = document.querySelector("[data-preorder-notify]");
  const notifyForm = document.querySelector("[data-preorder-notify-form]");
  const notifyEmail = document.querySelector("[data-notify-email]");
  const notifySend = document.querySelector("[data-notify-send]");
  const notifyMsg = document.querySelector("[data-notify-msg]");

  function notifyShowMsg(text, ok) {
    if (!notifyMsg) return;
    notifyMsg.textContent = text;
    notifyMsg.hidden = false;
    notifyMsg.dataset.state = ok ? "ok" : "err";
  }

  function fireKlaviyoNotify(email, variant) {
    const props = {
      Product: productMeta.title,
      ProductHandle: productMeta.handle,
      ProductId: productMeta.id,
      Variant: variant ? variant.options.join(" / ") : "",
      VariantId: variant ? String(variant.id) : "",
      Source: "PDP pre-order notify",
    };
    // Prefer the modern onsite object: identify() returns a Promise that resolves
    // once `email` is the ACTIVE profile, so firing track() in .then() guarantees
    // the event binds to THIS email and not a profile already cached in the session.
    // (Queuing identify + track back-to-back races: track can land on a previously
    // identified profile before identify() switches it. That was the sonny@/mike@ mixup.)
    if (window.klaviyo && typeof window.klaviyo.identify === "function") {
      try {
        const fireTrack = function () {
          window.klaviyo.track("Notify Me Requested", props);
        };
        const idp = window.klaviyo.identify({ email: email });
        if (idp && typeof idp.then === "function") {
          idp.then(fireTrack, fireTrack);
        } else {
          fireTrack();
        }
        return true;
      } catch (err) {}
    }
    // Legacy fallback (_learnq queue only): ordered but not awaited. Fine for a
    // first-touch visitor with no cached profile; real sessions hit the path above.
    if (window._learnq && typeof window._learnq.push === "function") {
      window._learnq.push(["identify", { $email: email }]);
      window._learnq.push(["track", "Notify Me Requested", props]);
      return true;
    }
    console.warn("[loonr] Klaviyo onsite object not found; notify-me not recorded.");
    return false;
  }

  function submitNotify() {
    flushPendingColor(); // the captured event names the variant on screen
    const email = ((notifyEmail && notifyEmail.value) || "").trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      notifyShowMsg("That email looks off. Mind checking it?", false);
      if (notifyEmail) notifyEmail.focus();
      return;
    }
    if (fireKlaviyoNotify(email, currentVariant)) {
      if (notifyEmail) notifyEmail.disabled = true;
      if (notifySend) notifySend.hidden = true;
      notifyShowMsg("You're on the list. We'll holler the second they land.", true);
    } else {
      notifyShowMsg("Hiccup on our end. Give it another go in a sec?", false);
    }
  }

  if (preorderNotifyBtn && notifyForm) {
    preorderNotifyBtn.addEventListener("click", (e) => {
      e.preventDefault();
      openNotifyCapture();
    });
  }
  if (notifySend) notifySend.addEventListener("click", submitNotify);
  if (notifyEmail) {
    notifyEmail.addEventListener("keydown", (e) => {
      if (e.key === "Enter") { e.preventDefault(); submitNotify(); }
    });
  }

  // Initial paint
  if (currentVariant) {
    if (sizeSelect) {
      paintSizeOptions(currentVariant.options[colorIndex]);
      if (sizeChosen) sizeSelect.value = currentVariant.options[sizeIndex];
      else sizeSelect.selectedIndex = 0; // the "Select size" placeholder
      if (activeUnit) repaintSizeLabels(activeUnit); // numbers-only from first paint (Mike 10/17)
    }
    syncAtcButton();
    const initialColor = currentVariant.options[colorIndex];
    // Apply initial color accent + enforce gallery cap on load (server-rendered
    // filter is already in place, but JS adds the per-color cap of GALLERY_CAP).
    applyColorAccent(initialColor);
    filterGalleryByColor(initialColor);
    applyColorwayDesc(initialColor);
    // Build carousel dots + attach scroll listener (mobile-only via CSS).
    buildGalleryDots();
    attachGalleryScroll();
    attachGalleryEdgeWrap();
    // Sticky ATC reveals only after the user scrolls past the in-flow ATC.
    attachStickyAtcReveal();
    // Deep-dive fact carousels (mobile-only via CSS, but JS runs always —
    // dots are hidden on desktop, scroll listener no-ops on a non-scrolling
    // container).
    attachFactCarousels();
    // PDP FAQ show-more toggle (reveals questions 7-12 / 6-11 depending on
    // silhouette). Toggleable so the user can collapse back.
    attachFaqMoreToggle();
  }

  function attachFaqMoreToggle() {
    const toggle = document.querySelector("[data-faq-more-toggle]");
    if (!toggle) return;
    const moreBlock = document.querySelector("[data-faq-more]");
    if (!moreBlock) return;
    const label = toggle.querySelector("[data-faq-more-label]");
    const moreCount = moreBlock.querySelectorAll(".acc").length;
    const labelOpen = "Show fewer";
    const labelClosed = "Show " + moreCount + " more questions";
    toggle.addEventListener("click", () => {
      const isExpanded = toggle.getAttribute("aria-expanded") === "true";
      if (isExpanded) {
        moreBlock.setAttribute("hidden", "");
        toggle.setAttribute("aria-expanded", "false");
        if (label) label.textContent = labelClosed;
      } else {
        moreBlock.removeAttribute("hidden");
        toggle.setAttribute("aria-expanded", "true");
        if (label) label.textContent = labelOpen;
      }
    });
  }

  // Deep-dive feature panel carousels. Each [data-dd-facts] is a scroll-snap
  // track on mobile. JS builds a row of dots, wires tap-to-jump, and tracks
  // active card via scrollLeft → card index match. Active dot is highlighted
  // with the brand red. CSS handles mobile-only display of the dots.
  function attachFactCarousels() {
    const tracks = document.querySelectorAll("[data-dd-facts]");
    tracks.forEach((track) => {
      const cards = Array.from(track.querySelectorAll(".dd-fact"));
      if (cards.length < 2) return;
      if (track.dataset.ddFactsInit === "1") return;
      track.dataset.ddFactsInit = "1";

      // Build dots in a sibling container right after the track.
      const dots = document.createElement("div");
      dots.className = "dd-facts-dots";
      dots.setAttribute("role", "tablist");
      dots.setAttribute("aria-label", "Feature carousel");
      cards.forEach((_, i) => {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.className = "dd-facts-dot" + (i === 0 ? " is-active" : "");
        dot.setAttribute("role", "tab");
        dot.setAttribute("aria-label", "Show fact " + (i + 1) + " of " + cards.length);
        dot.addEventListener("click", () => {
          cards[i].scrollIntoView({
            behavior: "smooth",
            inline: "start",
            block: "nearest",
          });
        });
        dots.appendChild(dot);
      });
      track.parentNode.insertBefore(dots, track.nextSibling);

      // Active dot tracking — find the card whose left edge is closest to
      // the track's effective left edge (16px scroll-padding accounted for).
      let raf = 0;
      function updateActive() {
        const trackRect = track.getBoundingClientRect();
        const targetX = trackRect.left + 16;
        let bestIdx = 0;
        let bestDist = Infinity;
        cards.forEach((c, i) => {
          const r = c.getBoundingClientRect();
          const dist = Math.abs(r.left - targetX);
          if (dist < bestDist) {
            bestDist = dist;
            bestIdx = i;
          }
        });
        const allDots = dots.querySelectorAll(".dd-facts-dot");
        allDots.forEach((d, i) => d.classList.toggle("is-active", i === bestIdx));
      }
      track.addEventListener(
        "scroll",
        () => {
          if (raf) return;
          raf = requestAnimationFrame(() => {
            updateActive();
            raf = 0;
          });
        },
        { passive: true }
      );
      // Run once after layout settles so the initial dot is correct even if
      // the browser restored a scroll position from history.
      requestAnimationFrame(updateActive);
    });
  }
})();

// Trust-grid flippable cards. CSS handles hover on desktop (via @media hover:hover).
// JS toggles `.is-flipped` for touch + keyboard so cards work without a pointer.
(function () {
  const cards = document.querySelectorAll("[data-trust-card]");
  if (!cards.length) return;
  cards.forEach((card) => {
    const back = card.querySelector(".trust-card__back");
    function setFlipped(state) {
      card.classList.toggle("is-flipped", state);
      card.setAttribute("aria-pressed", state ? "true" : "false");
      if (back) back.setAttribute("aria-hidden", state ? "false" : "true");
    }
    card.addEventListener("click", () => setFlipped(!card.classList.contains("is-flipped")));
    card.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        setFlipped(!card.classList.contains("is-flipped"));
      }
    });
  });
})();

/* Trust-box pop-ups: shipping / yuckproof / returns open an accessible modal;
   the reviews cell scrolls to #reviews. No localStorage. */
(function () {
  var modal = document.getElementById("trust-modal");
  if (!modal) return;
  var titleEl = modal.querySelector(".trust-modal__title");
  var panels = modal.querySelectorAll(".trust-modal__panel");
  var titles = { shipping: "Shipping", yuckproof: "Yuckproof guarantee", returns: "Returns & exchanges" };
  var lastTrigger = null;

  function openModal(key, trigger) {
    lastTrigger = trigger || null;
    if (titleEl) titleEl.textContent = titles[key] || "";
    panels.forEach(function (p) { p.hidden = p.getAttribute("data-panel") !== key; });
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("trust-modal-open");
    var closeBtn = modal.querySelector(".trust-modal__close");
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 40);
  }
  function closeModal() {
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("trust-modal-open");
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    lastTrigger = null;
  }

  document.querySelectorAll("[data-trust-modal]").forEach(function (btn) {
    btn.addEventListener("click", function () { openModal(btn.getAttribute("data-trust-modal"), btn); });
  });
  var reviewsBtn = document.querySelector('[data-trust-scroll="reviews"]');
  if (reviewsBtn) {
    reviewsBtn.addEventListener("click", function () {
      var t = document.getElementById("reviews");
      if (t) t.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }
  modal.querySelectorAll("[data-trust-close]").forEach(function (c) {
    c.addEventListener("click", closeModal);
  });
  // Real pointer clicks land on the .trust-modal overlay itself (the backdrop
  // child doesn't receive them), so close on any click outside the dialog.
  modal.addEventListener("click", function (e) {
    if (!e.target.closest(".trust-modal__dialog")) closeModal();
  });
  modal.addEventListener("keydown", function (e) {
    if (e.key !== "Tab") return;
    var nodes = modal.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
    var focusable = Array.prototype.filter.call(nodes, function (el) { return el.offsetParent !== null; });
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.getAttribute("aria-hidden") === "false") closeModal();
  });
})();

/* Size-guide modal — opens from [data-size-guide] (the link near the size selector + the
   fit-guide accordion link). Reuses .trust-modal chrome. No localStorage. */
(function () {
  var modal = document.getElementById("size-guide-modal");
  if (!modal) return;
  var lastTrigger = null;
  function openSG(trigger) {
    lastTrigger = trigger || null;
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("trust-modal-open");
    var c = modal.querySelector(".trust-modal__close");
    if (c) setTimeout(function () { c.focus(); }, 40);
  }
  function closeSG() {
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("trust-modal-open");
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
    lastTrigger = null;
  }
  document.querySelectorAll("[data-size-guide]").forEach(function (el) {
    el.addEventListener("click", function (e) { e.preventDefault(); openSG(el); });
  });
  modal.querySelectorAll("[data-sizeguide-close]").forEach(function (c) {
    c.addEventListener("click", closeSG);
  });
  // Same as the trust modal: clicks land on the overlay, not the backdrop child.
  modal.addEventListener("click", function (e) {
    if (!e.target.closest(".trust-modal__dialog")) closeSG();
  });
  modal.addEventListener("keydown", function (e) {
    if (e.key !== "Tab") return;
    var nodes = modal.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
    var f = Array.prototype.filter.call(nodes, function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && modal.getAttribute("aria-hidden") === "false") closeSG();
  });
})();
/* =============================================================
   Loon'r PDP — click-to-enlarge lightbox (Track 1, 2026-08-18).
   Click the hero or any gallery photo to open a full-screen viewer at 2048px.
   Prev/next cycle the current colorway's visible shots; Esc / tap-out / X close;
   swipe navigates on touch; tap the image toggles a closer zoom.
   Self-contained: no external libraries, no dependency on the picker IIFE.
   ============================================================= */
(function () {
  "use strict";
  var gallery = document.querySelector(".loonr-pdp .gallery");
  var hero = document.querySelector("[data-hero-img]");
  if (!gallery && !hero) return;

  function orderedShots() {
    if (!gallery) return [];
    return Array.prototype.slice.call(gallery.querySelectorAll(".shot:not([hidden])"))
      .sort(function (a, b) {
        return (parseInt(a.style.order || "0", 10)) - (parseInt(b.style.order || "0", 10));
      });
  }
  function hiRes(src) {
    if (!src) return src;
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, "$12048");
    return src + (src.indexOf("?") === -1 ? "?" : "&") + "width=2048";
  }

  var lb = document.createElement("div");
  lb.className = "pdp-lightbox";
  lb.setAttribute("aria-hidden", "true");
  lb.setAttribute("role", "dialog");
  lb.setAttribute("aria-modal", "true");
  lb.setAttribute("aria-label", "Product image viewer");
  lb.innerHTML =
    '<button class="pdp-lightbox__close" type="button" aria-label="Close viewer">×</button>' +
    '<button class="pdp-lightbox__nav pdp-lightbox__nav--prev" type="button" aria-label="Previous image">‹</button>' +
    '<figure class="pdp-lightbox__stage"><img class="pdp-lightbox__img" alt=""></figure>' +
    '<button class="pdp-lightbox__nav pdp-lightbox__nav--next" type="button" aria-label="Next image">›</button>' +
    '<div class="pdp-lightbox__count" data-lb-count></div>';
  document.body.appendChild(lb);
  var lbImg = lb.querySelector(".pdp-lightbox__img");
  var lbStage = lb.querySelector(".pdp-lightbox__stage");
  var lbCount = lb.querySelector("[data-lb-count]");
  var closeBtn = lb.querySelector(".pdp-lightbox__close");
  var slides = [];
  var idx = 0;
  var renderToken = 0;
  var lastFocus = null;
  var lbRelease = null; // active focus-trap release fn (loonr-dialog.js), null when closed

  function collectSlides() {
    var out = [], seen = {};
    function add(src, alt) {
      if (!src) return;
      var key = src.split("?")[0];
      if (seen[key]) return;
      seen[key] = 1;
      // lo = the rendition the gallery already has in cache; src = the 2048px file.
      out.push({ src: hiRes(src), lo: src, alt: alt || "" });
    }
    if (hero && hero.src) add(hero.currentSrc || hero.src, hero.alt);
    orderedShots().forEach(function (shot) {
      var im = shot.querySelector("img");
      if (im) add(im.currentSrc || im.src, im.alt);
    });
    return out;
  }
  function render() {
    if (!slides.length) return;
    idx = (idx % slides.length + slides.length) % slides.length;
    lbStage.classList.remove("is-zoomed");
    clearZoomFit();
    lbStage.scrollTop = 0; lbStage.scrollLeft = 0;
    // One <img> is reused for every slide. Just swapping its src left the PREVIOUS photo on
    // screen until the new 2048px file arrived, so opening a photo flashed the last one you
    // had looked at (Mike, 2026-09-19; obvious on uncached photos). Hide the stale photo at
    // once, show the gallery's already-cached rendition of THIS photo, then upgrade to the
    // 2048px file once it has loaded. renderToken drops late loads from a slide we have left.
    var s = slides[idx], token = ++renderToken;
    lbImg.classList.add("is-swapping");
    lbImg.onload = lbImg.onerror = function () { if (token === renderToken) lbImg.classList.remove("is-swapping"); };
    lbImg.src = s.lo || s.src;
    lbImg.alt = s.alt;
    if (s.lo && s.lo !== s.src) {
      var pre = new Image();
      pre.onload = function () { if (token === renderToken) lbImg.src = s.src; };
      pre.src = s.src;
    }
    lbCount.textContent = (idx + 1) + " / " + slides.length;
    var multi = slides.length > 1;
    Array.prototype.forEach.call(lb.querySelectorAll(".pdp-lightbox__nav"), function (n) { n.hidden = !multi; });
    lbCount.hidden = !multi;
  }
  function openAt(src) {
    slides = collectSlides();
    if (!slides.length) return;
    var key = (src || "").split("?")[0], f = -1;
    for (var i = 0; i < slides.length; i++) { if (slides[i].src.split("?")[0] === key) { f = i; break; } }
    idx = f >= 0 ? f : 0;
    lastFocus = document.activeElement;
    render();
    lb.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("pdp-lightbox-open");
    // Trap Tab inside the viewer (shared helper, loonr-dialog.js). Without it,
    // Tab walks onto the fully-obscured page behind the 92%-opaque overlay.
    // Also sets #MainContent inert (the viewer is body-appended, so it survives).
    if (window.loonrDialog && !lbRelease) lbRelease = window.loonrDialog.trap(lb);
    closeBtn.focus();
  }
  function close() {
    lb.setAttribute("aria-hidden", "true");
    clearZoomFit();
    document.documentElement.classList.remove("pdp-lightbox-open");
    lbStage.classList.remove("is-zoomed");
    if (lbRelease) { lbRelease(); lbRelease = null; }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function nav(d) { idx += d; render(); }
  function isOpen() { return lb.getAttribute("aria-hidden") === "false"; }

  if (hero) {
    hero.style.cursor = "zoom-in";
    hero.addEventListener("click", function () { openAt(hero.currentSrc || hero.src); });
  }
  if (gallery) {
    gallery.addEventListener("click", function (e) {
      var im = e.target.closest(".shot img");
      if (!im) return;
      e.preventDefault();
      openAt(im.currentSrc || im.src);
    });
    // Keyboard operability (WCAG 2.1.1, Level A): the shots are bare <img>s whose
    // only affordance is this click delegation, so keyboard users could not open
    // a single gallery image. Make every shot image a focusable button and let
    // Enter/Space take the exact same openAt() path as a click. Applied in JS
    // (not Liquid) so all three figure markup shapes are covered identically —
    // and because without JS there is no viewer to operate anyway. Hidden
    // figures ([hidden] on color switch) are unfocusable while hidden, so the
    // tab order always matches the visible gallery.
    Array.prototype.forEach.call(gallery.querySelectorAll(".shot img"), function (im) {
      im.setAttribute("tabindex", "0");
      im.setAttribute("role", "button");
      var alt = im.getAttribute("alt") || "Product photo";
      im.setAttribute("aria-label", alt + " (open larger view)");
    });
    gallery.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " " && e.key !== "Spacebar") return;
      var im = e.target.closest ? e.target.closest(".shot img") : null;
      if (!im) return;
      e.preventDefault(); // stop Space from page-scrolling
      openAt(im.currentSrc || im.src);
    });
  }
  // The hero image opens the viewer too — same treatment.
  if (hero) {
    hero.setAttribute("tabindex", "0");
    hero.setAttribute("role", "button");
    hero.setAttribute("aria-label", (hero.getAttribute("alt") || "Product photo") + " (open larger view)");
    hero.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " " && e.key !== "Spacebar") return;
      e.preventDefault();
      openAt(hero.currentSrc || hero.src);
    });
  }
  closeBtn.addEventListener("click", close);
  lb.querySelector(".pdp-lightbox__nav--prev").addEventListener("click", function () { nav(-1); });
  lb.querySelector(".pdp-lightbox__nav--next").addEventListener("click", function () { nav(1); });
  lb.addEventListener("click", function (e) { if (e.target === lb || e.target === lbStage) close(); });
  // Zoom step: crop the dead space, don't just magnify. These studio shots are
  // square with ~50% white margin (measured: LR_BLK_225 boot fills 75%x62% of
  // the frame), so scaling alone mostly enlarges background. We find the boot's
  // real bounds on a downsampled canvas (same-origin, so pixel reads are legal),
  // then scale + recentre so the BOOT fills the panel. Nothing is cut off: the
  // scale factor keys off the tighter axis. Lifestyle shots have little white,
  // so k lands near 1 and they simply behave as before.
  var boxCache = {};
  function bootBox(src) {
    if (boxCache[src]) return Promise.resolve(boxCache[src]);
    return new Promise(function (resolve) {
      var im = new Image();
      im.onerror = function () { resolve(null); };
      im.onload = function () {
        try {
          var S = 220, c = document.createElement("canvas");
          c.width = S; c.height = S;
          var ctx = c.getContext("2d", { willReadFrequently: true });
          ctx.drawImage(im, 0, 0, S, S);
          var d = ctx.getImageData(0, 0, S, S).data;
          var x0 = S, y0 = S, x1 = 0, y1 = 0;
          for (var y = 0; y < S; y++) {
            for (var x = 0; x < S; x++) {
              var i = (y * S + x) * 4;
              if ((d[i] + d[i + 1] + d[i + 2]) / 3 < 244) {
                if (x < x0) x0 = x; if (x > x1) x1 = x;
                if (y < y0) y0 = y; if (y > y1) y1 = y;
              }
            }
          }
          if (x1 <= x0 || y1 <= y0) { resolve(null); return; }
          var bw = (x1 - x0) / S, bh = (y1 - y0) / S;
          var pad = 1.06; // a little air so the boot never kisses the frame
          var box = {
            cx: ((x0 + x1) / 2) / S,
            cy: ((y0 + y1) / 2) / S,
            k: Math.min(2.2, Math.max(1, 1 / (Math.max(bw, bh) * pad)))
          };
          boxCache[src] = box;
          resolve(box);
        } catch (err) { resolve(null); }
      };
      im.src = src;
    });
  }
  function clearZoomFit() { lbImg.style.transform = ""; }
  // Desktop only. Mobile's zoom step is a 175% pan-and-scan (base .is-zoomed
  // rule) that Mike is happy with; a crop transform would compound with it.
  function zoomFitEnabled() { return window.matchMedia("(min-width: 641px)").matches; }
  function applyZoomFit() {
    if (!zoomFitEnabled()) return;
    var src = lbImg.src;
    bootBox(src).then(function (box) {
      // guard: the slide may have changed or been un-zoomed while we decoded
      if (!box || lbImg.src !== src || !lbStage.classList.contains("is-zoomed")) return;
      var tx = (0.5 - box.cx) * 100, ty = (0.5 - box.cy) * 100;
      lbImg.style.transform = "scale(" + box.k.toFixed(3) + ") translate(" + tx.toFixed(2) + "%, " + ty.toFixed(2) + "%)";
    });
  }

  lbImg.addEventListener("click", function (e) {
    e.stopPropagation();
    var zoomed = lbStage.classList.toggle("is-zoomed");
    if (zoomed) applyZoomFit(); else clearZoomFit();
  });
  document.addEventListener("keydown", function (e) {
    if (!isOpen()) return;
    if (e.key === "Escape") close();
    else if (e.key === "ArrowLeft") nav(-1);
    else if (e.key === "ArrowRight") nav(1);
  });
  var tx = 0, ty = 0;
  lbStage.addEventListener("touchstart", function (e) {
    if (e.touches.length !== 1) return;
    tx = e.touches[0].clientX; ty = e.touches[0].clientY;
  }, { passive: true });
  lbStage.addEventListener("touchend", function (e) {
    if (lbStage.classList.contains("is-zoomed") || e.changedTouches.length !== 1) return;
    var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) nav(dx < 0 ? 1 : -1);
  }, { passive: true });
})();
